import { Component } from '@angular/core';
import 'moment/locale/id';
import * as moment from 'moment';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { BaseListBComponent } from '../../../libraries/base/list/base-list.bcomponent';
import { PromoRestService } from '../promo-rest.service';

@Component({
  selector: 'app-promo-list',
  templateUrl: 'promo-list.component.html'
})
export class PromoListComponent extends BaseListBComponent<any> {
  tableColumns: IGridTableColumn[] = [
    {
      i18nLabel: 'ui.promo.entity.title',
      field: 'title',
      sort: true
    },
    {
      i18nLabel: 'ui.promo.entity.period',
      field: 'period'
    },
    {
      i18nLabel: 'ui.promo.entity.createdDate',
      field: 'createdAt',
      sort: true
    },
  ];
  tableColumnsShow: boolean = false;
  tableColumnsToggle = this._gridTableToggle.mapToggleOptionsFromColumns(
    this.tableColumns
  );

  constructor(private _promoRest: PromoRestService) {
    super();
    this.componentId = 'PromoListComponent';
    this.headerTitle = 'ui.promo.list.title';
    this.exportFileName = 'user';
    this.exportDocumentTitle = 'ui.promo.list.title';
    this.deleteRecordI18nLabel = 'confirm.any.delete.label';
    this.deleteRecordI18nDescription = 'confirm.any.delete.description';
    this.deleteRecordI18nSuccess = 'success.promo.delete';

    this.headerButtons = [
      {
        type: 'custom',
        label: 'ui.promo.list.button.create',
        color: 'primary-outline',
        routerLink: '/promo/create'
        // permissions: ['user.create']
      }
    ];
  }

  appDefineFixedHooks() {
    super.appDefineFixedHooks();

    this.registerHook({
      hookName: 'loadData',
      handle: event => {
        const qOption = event.data.qOption;
        const qParams = Object.assign(
          {},
          event.data.qParams,
          qOption,
          this.qParams
        );

        return this._promoRest.findAll(qParams).pipe(
          switchMap(doc => {
            const dataFormatted = doc?.data?.map(d => {
              d.createdAt = moment(d?.createdAt).format('DD MMMM, YYYY');

              return d;
            });
            doc.data = dataFormatted;
            return of(doc);
          })
        );
      },
      wrapRetryableTask: true,
      wrapErrorMessage: true
    });

    this.registerHook({
      hookName: 'deleteRecord',
      handle: event => {
        const promoId = event.data._id;
        return this._promoRest.delete(promoId);
      },
      wrapRetryableTask: true,
      wrapLoadingComponentIds: this.componentId,
      wrapErrorMessage: true
    });

    this.registerHook({
      hookName: 'init',
      handle: () =>
        this.page.compHookService.callMultipleHooks([
          'PromoListComponent:workflowLoadData'
        ])
    });
  }

  appOnInit() {
    super.appOnInit();

    return this.callHook('init');
  }
}
